import EditFieldModal from "@/modules/common/components/modals/edit-field-modal";
import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { showToast } from "@/modules/common/utils";
import { useUnpublishListing } from "@/modules/property-tracks/hooks/listings/unpublish-listing.hook";
import { Typography } from "@mui/material";

export default function UnpublishListingModal({
  listingUid,
  open,
  setOpen,
}: {
  listingUid: string;
  open: boolean;
  setOpen: (value: boolean) => void;
}) {

  const mutation = useUnpublishListing();

  const handleConfirm = () => {
    mutation.mutate(listingUid, {
      onSuccess: () => {
        handleModalClose();
        showToast({
          type: ToastType.SUCCESS,
          message: "Listing unpublished successfully",
          toastId: TOAST_IDS.UNPUBLISH_LISTING_SUCCESS,
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
      },
      onError: (error) => {
        showToast({
          type: ToastType.ERROR,
          message:
            error?.response?.data?.message ||
            "Unexpected error occurred. Please try again.",
          toastId: TOAST_IDS.UNPUBLISH_LISTING_ERROR,
          options: {
            position: "bottom-left",
            autoClose: 3000,
          },
        });
      },
    });
  };

  const handleModalOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };

  return (
    <EditFieldModal
      open={open}
      setOpen={handleModalOpen}
      header="Unpublish listing"
      width={480}
      handleConfirm={handleConfirm}
      handleCloseModal={handleModalClose}
      isLoading={mutation.isPending}
      confirmText="Unpublish"
    >
      <Typography
        sx={(t) => t.nawy.typography.english.variants.body.md.regular}
      >
        Are you sure you want to unpublish this listing?
      </Typography>
    </EditFieldModal>
  );
}
